import React from 'react';
import { motion } from 'framer-motion';
interface GlowCardProps {
  children: React.ReactNode;
  className?: string;
  glowColor?: string;
  hoverScale?: boolean;
}
export function GlowCard({
  children,
  className = '',
  glowColor = '#C9A84C',
  hoverScale = false
}: GlowCardProps) {
  return <motion.div className={`relative bg-cosmic-darker border border-opacity-30 rounded-lg p-6 ${className}`} style={{
    borderColor: glowColor,
    boxShadow: `0 0 20px ${glowColor}20`
  }} whileHover={hoverScale ? {
    scale: 1.02,
    boxShadow: `0 0 30px ${glowColor}40`,
    transition: {
      duration: 0.3
    }
  } : {}} data-id="element-697">
      {children}
    </motion.div>;
}